module.exports = __webpack_public_path__ + "img/banner_left.064908be.png";